// extracted by mini-css-extract-plugin
module.exports = {"title":"PhoneVerifyModal_title__lhIxV","subtitle":"PhoneVerifyModal_subtitle__q3h_i"};